angular.module('impactx.productcoding').controller('ProductCodingTreeCtrl', [
    'dataGen',
    'ToolbarService',
    '$timeout',
    '$redirect',
    '$mdDialog',
    'TranslationService',
    '$routeParams',
    'ToastService',
    'ConfirmationService',
    ProductCodingTreeCtrl
]);

function ProductCodingTreeCtrl(dataGen, ToolbarService, $timeout, $redirect, $mdDialog, TranslationService,
                               $routeParams, ToastService, ConfirmationService) {
    var self = this;
    self.requestInProgress = false;
    self.breadcrumbs = [{id: 0, label: 'Root', type: 'VCATALOG'}];
    self.selectedNode = {};
    self.selectedEntries = [];
    self.selectedEntriesNew = [];
    self.searchLabel = TranslationService.get("search");
    self.filter = {value: ""};
    self.filterCat = {value: ""};
    self.newFilter = {value: ""};
    self.hasMoreResultsLabel = TranslationService.get("hasMoreResults");
    self.allSelected = {value: false};
    self.allSelectedNew = {value: false};
    self.selectedTrns = TranslationService.get('selected');
    self.hadNewEntries = false;

    self.toggle = function (event, entry, open, overflowMarker) {
        if (self.selectedNode && self.filter.value && self.filter.value.length > 0) {
            var updateNode = self.selectedNode;
            self.filter.value = "";
            getSubNodes(self.selectedNode).then(function (data) {
                updateNode.entries = undefined;
                var newEntries = impactX.isDefined(data, 'data.entries');
                if (newEntries) {
                    applyItemList(newEntries, updateNode);
                }
            });
            self.toggleInternal(event, entry, open, overflowMarker);
        }
        else {
            self.toggleInternal(event, entry, open, overflowMarker);
        }
    };

    self.toggleInternal = function (event, entry, open, overflowMarker) {

        for (var i = 0; i < self.selectedEntries.length; i++) {
            self.selectedEntries[i].selected = false;
        }
        self.allSelected.value = false;
        self.selectedEntries.length = 0;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (overflowMarker) {
            return;
        }
        if (entry.isLeaf) {
            return;
        }
        var foundEntryInTree = findEntry(entry);
        if (foundEntryInTree) {
            entry = foundEntryInTree;
        }

        if (open) {
            entry.isOpen = true;
        }
        else {
            entry.isOpen = !entry.isOpen;
        }

        if (entry.isOpen && !entry.entries) {
            getSubNodes(entry).then(function (data) {
                var newEntries = impactX.isDefined(data, 'data.entries');
                if (newEntries) {
                    applyItemList(newEntries, entry);
                    self.selectedNode = entry;
                }
            });
        }
        else {
            if (!entry.isOpen && entry.entries && !entry.isLeaf) {
                //has just been closed -> build sub bread bread crumb and set super node as selected
                self.selectedNode = entry;
                setSelectedNode(self.selectedNode);
                var newBreadCrumb = [];
                for (let i = 0; i < self.breadcrumbs.length; i++) {
                    if (self.breadcrumbs[i].id === entry.id &&
                        self.breadcrumbs[i].type === entry.type) {
                        break;
                    }
                    newBreadCrumb.push(self.breadcrumbs[i]);
                }
                self.breadcrumbs = newBreadCrumb;
                self.selectedNode = newBreadCrumb[newBreadCrumb.length - 1];
            }
            else {
                self.selectedNode = entry;
                setSelectedNode(self.selectedNode);
            }
        }
    }

    function findEntry(entry, compareEntry) {
        if (compareEntry && entry.id === compareEntry.id && entry.type === compareEntry.type) {
            return compareEntry;
        }
        if (!compareEntry) {
            for (let i = 0; i < self.data.entries.length; i++) {
                let foundEntry = findEntry(entry, self.data.entries[i]);
                if (foundEntry) {
                    return foundEntry;
                }
            }
        }
        else if (compareEntry.entries) {
            for (let i = 0; i < compareEntry.entries.length; i++) {
                let foundEntry = findEntry(entry, compareEntry.entries[i]);
                if (foundEntry) {
                    return foundEntry;
                }
            }
        }

    }

    function findEntryNew(entry) {
        for (let i = 0; i < self.data.newEntries.length; i++) {
            var compareEntry = self.data.newEntries[i];
            if (compareEntry && entry.id === compareEntry.id && entry.type === compareEntry.type) {
                return compareEntry;
            }
        }
    }

    self.getIconClass = function (entry) {
        var result = '';

        switch (entry.type) {
            case "VCATALOG":
                result += (entry.coding ? 'mdi-icon-green' : 'mdi-icon-dark-grey') + ' mdi-book';
                break;
            case "PRG":
                result += (entry.coding ? 'mdi-icon-green' : 'mdi-icon-dark-grey') + ' mdi-folder';
                break;
            case "PRO":
                result += (entry.coding ? 'mdi-icon-green' : 'mdi-icon-dark-grey') + ' mdi-cog';
                break;
            default:
                return "";
        }

        return result;
    }

    self.goToDetails = function (event, entry, open) {
        switch (entry.type) {
            case "VCATALOG":
                $redirect.redirectTo(null, "/internalcatalog/" + entry.id);
                break;
            case "PRG":
                $redirect.redirectTo(null, "/personaldata/" + entry.id);
                break;
            case "PRO":
                $redirect.redirectTo(null, "/contract/" + entry.id);
                break;
        }
    };

    function chunk(arr, len) {
        var chunks = [],
            i = 0,
            n = arr.length;

        while (i < n) {
            chunks.push(arr.slice(i, i += len));
        }

        return chunks;
    }

    function applyItemList(items, data) {
        var chunks = chunk(items, 100);
        data.entries = chunks[0];

        var delay = 100;
        angular.forEach(chunks, function (value, index) {
            delay += 100;

            if (index > 0) {
                $timeout(function () {
                    data.entries = data.entries.concat(value);
                }, delay);
            }
        });
    }

    function applyItemListNew(source, target) {
        var items = source.newEntries;
        if (items) {
            target.hasMoreNewElements = source.hasMoreNewElements;
            var chunks = chunk(items, 100);
            target.newEntries = chunks[0];

            var delay = 100;
            angular.forEach(chunks, function (value, index) {
                delay += 100;

                if (index > 0) {
                    $timeout(function () {
                        target.newEntries = target.newEntries.concat(value);
                    }, delay);
                }
            });
            if (!self.hadNewEntries) {
                self.hadNewEntries = target.newEntries.length > 0;
            }
        }
    }

    function applyItemListFiltered(items, data) {
        var chunks = chunk(items, 100);
        data.filteredEntries = chunks[0];

        var delay = 100;
        angular.forEach(chunks, function (value, index) {
            delay += 100;

            if (index > 0) {
                $timeout(function () {
                    data.filteredEntries = data.filteredEntries.concat(value);
                }, delay);
            }
        });
    }

    self.getRootNodes = function (selected, init, updateCats) {
        if (!updateCats) {
            self.selectedEntriesNew.length = 0;
        }
        if (selected || init) {
            var result = null;
            if (self.data) {
                result = {};
                angular.copy(self.data, result);
                if (selected) {
                    result.company.selected = selected;
                }
                delete result.entries;
            }
            var newCatIdToSet = $routeParams.newCatId ? $routeParams.newCatId : 0;
            self.requestInProgress = true;
            var searchText = self.filterCat.value ? self.filterCat.value : "";
            return dataGen.postAsForm(!result ? self : {}, result ? {data: result, newCatId: newCatIdToSet, newFilter: self.newFilter.value, searchText: searchText} :
                {newCatId: newCatIdToSet, newFilter: self.newFilter.value, searchText: searchText}, '/productcodinghierarchy/root').then(function (data) {
                if (result) {
                    applyItemList(data.data.entries, self.data);
                    if (!updateCats) {
                        applyItemListNew(data.data, self.data);
                    }
                }
                self.requestInProgress = false;
                self.selectedNode = {};
                self.breadcrumbs = [{id: 0, label: 'Root', type: 'VCATALOG'}];
                if (init) {
                    defineButtons();
                }
            });
        }
        else
        {
            if (self.data && self.data.entries) {
                delete self.data.entries;
            }
        }
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: self.trns.edit,
                action: self.editEntries,
                type: 'dialogaction',
                condition: function () {
                    return self.selectedEntries.length > 0 && !self.selectedEntriesNew.length
                }
            },
            {
                label: self.trns.edit,
                action: self.editEntriesNew,
                type: 'dialogaction',
                condition: function () {
                    return self.selectedEntriesNew.length > 0 &&  !self.selectedEntries.length
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function getSubNodes(entry) {
        var result = null;
        if (self.data) {
            result = {};
            angular.copy(self.data, result);
            delete result.entries;
            result.selected = entry;
        }
        setSelectedNode(entry);

        self.requestInProgress = true;
        return dataGen.postAsForm({}, {data: result, filter: self.filter.value}, '/productcodinghierarchy/sub').then(function (data) {
            entry.hasMoreElements = data.data.hasMoreElements;
            self.requestInProgress = false;
            return data;
        });
    }

    function setSelectedNode(selectedEntry) {
        if (!selectedEntry.isLeaf) {
            self.breadcrumbs = [{id: 0, label: 'Root', type: 'VCATALOG'}];

            for (let i = 0; i < self.data.entries.length; i++) {
                let entry = self.data.entries[i];
                if (entry.isOpen) {
                    let foundBreadCrumbWithEntry = buildBreadCrumb(entry, selectedEntry);
                    if (foundBreadCrumbWithEntry) {
                        angular.copy(foundBreadCrumbWithEntry, self.breadcrumbs);
                    }
                }
            }
        }
        $timeout(function () {
            if (self.breadcrumbs && self.breadcrumbs.length > 2) {
                let element = angular.element('#breadcrumb')[0];
                self.hasOverflow = element.scrollWidth > element.clientWidth;
                if (self.hasOverflow) {
                    self.breadcrumbs = [{id: 0, label: "...", overflowMarker: true}].concat(self.breadcrumbs);
                    cutOffOverflowingCrumbs();
                }
            }
        });
    }

    function cutOffOverflowingCrumbs()
    {
        self.breadcrumbs.splice(1, 1);
        $timeout(function () {
            let element = angular.element('#breadcrumb')[0];
            if (element.scrollWidth > element.clientWidth) {
                cutOffOverflowingCrumbs();
            }
        });
    }

    function buildBreadCrumb(rootNode, selectedEntry) {
        if (rootNode && rootNode.isOpen) {
            let breadCrumb = [{id: 0, label: 'Root', type: 'VCATALOG'}];
            breadCrumb.push(rootNode);
            if (rootNode.id === selectedEntry.id &&
                rootNode.type === selectedEntry.type) {
                return breadCrumb;
            }
            if (rootNode.entries) {
                for (let i = 0; i < rootNode.entries.length; i++) {
                    let foundSub = buildSubBreadCrumb(rootNode.entries[i], selectedEntry);
                    if (foundSub) {
                        breadCrumb = breadCrumb.concat(foundSub);
                        return breadCrumb;
                    }
                }
            }
        }
        return false;
    }

    function buildSubBreadCrumb(node, selectedEntry) {
        if (node.id === selectedEntry.id &&
            node.type === selectedEntry.type) {
            let toReturn = [];
            toReturn.push(node);
            return toReturn;
        }
        if (node && node.isOpen) {
            if (node.entries) {
                for (let i = 0; i < node.entries.length; i++) {
                    let foundSub = buildSubBreadCrumb(node.entries[i], selectedEntry);
                    if (foundSub)
                    {
                        let toReturn = [];
                        toReturn.push(node);
                        toReturn = toReturn.concat(foundSub);
                        return toReturn;
                    }
                }
            }
        }
        return null;
    }

    self.getRootNodes(null, true);

    self.selectEntry = function (entry) {
        if (entry.selected) {
            var index = self.selectedEntries.indexOf(entry);
            if (index > -1) {
                self.selectedEntries.splice(index, 1);
            }
        }
        else {
            self.selectedEntries.push(entry)
        }
        entry.selected = !entry.selected;
    }

    self.selectEntryNew = function (entry) {
        if (entry.selected) {
            var index = self.selectedEntriesNew.indexOf(entry);
            if (index > -1) {
                self.selectedEntriesNew.splice(index, 1);
            }
        }
        else {
            self.selectedEntriesNew.push(entry)
        }
        entry.selected = !entry.selected;
    }

    self.selectedChange = function (entry) {
        var wasSelected = !entry.selected;
        if (wasSelected) {
            var index = self.selectedEntries.indexOf(entry);
            if (index > -1) {
                self.selectedEntries.splice(index, 1);
            }
        }
        else {
            self.selectedEntries.push(entry)
        }
    }

    self.selectedChangeNew = function (entry) {
        var wasSelected = !entry.selected;
        if (wasSelected) {
            var index = self.selectedEntriesNew.indexOf(entry);
            if (index > -1) {
                self.selectedEntriesNew.splice(index, 1);
            }
        }
        else {
            self.selectedEntriesNew.push(entry)
        }
    }

    self.selectAll = function () {
        if (self.selectedEntries.length > 0) {
            self.allSelected.value = false;
            for (var i = 0; i < self.selectedEntries.length; i++) {
                self.selectedEntries[i].selected = false;
            }
            self.selectedEntries.length = 0;
        }
        else {
            self.allSelected.value = true;
            for (var i = 0; i < self.selectedNode.entries.length; i++) {
                var entry = self.selectedNode.entries[i];
                entry.selected = true;
                self.selectedEntries.push(entry)
            }
        }
    }

    self.selectAllNew = function () {
        if (self.selectedEntriesNew.length > 0) {
            self.allSelectedNew.value = false;
            for (var i = 0; i < self.selectedEntriesNew.length; i++) {
                self.selectedEntriesNew[i].selected = false;
            }
            self.selectedEntriesNew.length = 0;
        }
        else {
            self.allSelectedNew.value = true;
            for (var i = 0; i < self.data.newEntries.length; i++) {
                var entry = self.data.newEntries[i];
                entry.selected = true;
                self.selectedEntriesNew.push(entry)
            }
        }
    }

    self.editEntry = function (event, entry) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        self.edit(event, [entry], entry);
    }

    self.addEntries = function (event, entryToAddItemsTo) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        ConfirmationService.showConfirmationDialog(self.addEntriesFinal, event, self.trns.copyConfirm,
            self.trns.copy, TranslationService.get("abort"), null, entryToAddItemsTo);
    }

    self.addEntriesFinal = function (event, entryToAddItemsTo) {
        self.addInProgress = true;
        dataGen.postAsForm({}, {selectedNodes: self.selectedEntriesNew, entryToAddItemsTo: entryToAddItemsTo},
            '/productcodinghierarchy/addnodes').then(function (addNodesData) {
                self.addInProgress = false;
                if (addNodesData.data.multiSelectedItems) {
                    $mdDialog.show({
                        controller: "ProductCodingMultiSelectedDialogCtrl",
                        controllerAs: "productCodingMultiSelectedDialogCtrl",
                        templateUrl: 'modules/productcoding/templates/product-coding-multi-select-dialog.tmpl.html',
                        targetEvent: event,
                        parent: angular.element(document.body),
                        locals: {
                            multiSelectedItems: addNodesData.data.multiSelectedItems,
                            multiSelectedTrns: self.trns.multiSelected,
                            noElementsCopiedTrns: self.trns.noElementsCopied
                        },
                        bindToController: true,
                        clickOutsideToClose: false
                    });
                }
                else {
                    if (entryToAddItemsTo) {
                        getSubNodes(entryToAddItemsTo).then(function (data) {
                            entryToAddItemsTo.entries = undefined;
                            var foundEntryInTree = findEntry(entryToAddItemsTo);
                            if (foundEntryInTree) {
                                foundEntryInTree.entries = undefined;
                            }
                            self.toggle(event, entryToAddItemsTo, true)
                            var newEntries = impactX.isDefined(data, 'data.entries');
                            entryToAddItemsTo.coding = impactX.isDefined(data, 'data.entry.coding');
                            if (newEntries) {
                                applyItemList(newEntries, entryToAddItemsTo);
                            }
                        });
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                    }
                }
        },function () {
            self.addInProgress = false;
        });
    }

    self.editEntries = function (event) {
        self.edit(event, self.selectedEntries, self.selectedNode);
    }

    self.editEntriesNew = function (event) {
        self.edit(event, self.selectedEntriesNew, null, true);
    }

    self.edit = function (event, entries, entryToReload, reloadNewEntries) {
        $mdDialog.show({
            templateUrl: 'modules/productcoding/templates/product-coding-edit.dialog.tmpl.html',
            controller: "ProductCodingEditDialogCtrl",
            controllerAs: "productCodingEditDialogCtrl",
            targetEvent: event,
            locals: {
                entries: entries,
                comId: self.data.company.selected.id
            },
            bindToController: true,
            clickOutsideToClose: false
        }).then(function () {
            if (entryToReload) {
                getSubNodes(entryToReload).then(function (data) {
                    entryToReload.entries = undefined;
                    var foundEntryInTree = findEntry(entryToReload);
                    if (foundEntryInTree) {
                        foundEntryInTree.entries = undefined;
                    }
                    self.toggle(event, entryToReload, true)
                    var newEntries = impactX.isDefined(data, 'data.entries');
                    entryToReload.coding = impactX.isDefined(data, 'data.entry.coding');
                    if (newEntries) {
                        applyItemList(newEntries, entryToReload);
                    }
                });
            }
            if (reloadNewEntries) {
                var newCatIdToSet = $routeParams.newCatId ? $routeParams.newCatId : 0;
                if (newCatIdToSet > 0) {
                    self.requestInProgress = true;
                    return dataGen.postAsForm({}, {data: self.data, newCatId: newCatIdToSet, newFilter: self.newFilter.value},
                        '/productcodinghierarchy/newentries').then(function (data) {
                        var newEntries = impactX.isDefined(data, 'data.newEntries');
                        if (newEntries) {
                            for (let i = 0; i < newEntries.length; i++) {
                                var newEntry = newEntries[i];
                                var foundCurrentNewEntry = findEntryNew(newEntry);
                                if (foundCurrentNewEntry) {
                                    foundCurrentNewEntry.coding = impactX.isDefined(newEntry, 'coding');
                                }
                            }
                        }
                    });
                }
            }
        });
    }

    self.refreshCurrentEntries = function () {
        if (self.selectedNode) {
            getSubNodes(self.selectedNode).then(function (data) {
                self.selectedNode.entries = undefined;
                var newEntries = impactX.isDefined(data, 'data.entries');
                if (newEntries) {
                    applyItemList(newEntries, self.selectedNode);
                }
                self.allSelected.value = false;
                self.selectedEntries.length = 0;
            });
        }
    }

    self.refreshNewEntries = function () {
        var newCatIdToSet = $routeParams.newCatId ? $routeParams.newCatId : 0;
        if (newCatIdToSet > 0) {
            self.requestInProgress = true;
            return dataGen.postAsForm({}, {data: self.data, newCatId: newCatIdToSet, newFilter: self.newFilter.value},
                '/productcodinghierarchy/newentries').then(function (data) {
                applyItemListNew(data.data, self.data);
            });
        }
    }

    self.redirectToList = function () {
        $redirect.redirectTo(null, "productcodinglist/" + self.data.company.selected.id + "/" + self.breadcrumbs[1].id + "/" +
            (self.breadcrumbs.length > 2 ? self.breadcrumbs[self.breadcrumbs.length - 1].id : 0));
    }
}